import Vue from 'vue';
import Vuex from 'vuex';
import callsModule from './modules/callsModule';
import savedFormsModule from './modules/savedFormsModule';
import sourceModule from "./modules/sourceModule"; // Подключаем callsModule
import newOrdersModule from "./modules/newOrdersModule"; // Новые заказы
import chatModule from "./modules/chatModule"; // Модуль чатов
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    sourceModule,
    newOrdersModule,
    callsModule,
    savedFormsModule,
    chatModule
  },
  state: {
    filters: {}, // Объект для хранения фильтров
    currentPage: 1, // Текущая страница
    perPage: 30, // Значение по умолчанию
    sort: { currentSort: null, currentSortDir: 'desc' }, // Текущая сортировка
    user: JSON.parse(localStorage.getItem('user')) || null,
    productsByOrderId: {},
    namesManager: [
        { "label": "Евгений Китун", "value": 297, "phone_extension": 151, "password": "KitunEv!151Z9" },
        { "label": "Максим Бугаев", "value": 295, "phone_extension": 172, "password": "BugaevMa!172A5" },
        { "label": "Алексей Борисёнок", "value": 294, "phone_extension": 185, "password": "BorisenokAl!185X8" },
        { "label": "Андрей Алехнович", "value": 293, "phone_extension": 183, "password": "AlekhnovichAn!183R2" },
        { "label": "Андрей Еленский", "value": 292, "phone_extension": 178, "password": "ElenskyAn!178T4" },
        { "label": "Андрей Борозна", "value": 291, "phone_extension": 202, "password": "BorznaAn!202B7" },
        { "label": "Роман Буйдо", "value": 290, "phone_extension": 207, "password": "BuydoRo!207M3" },
        { "label": "Виталий Николаенко", "value": 278, "phone_extension": 114, "password": "NikolaenkoVi!114L1" },
        { "label": "Эдуард Дашковский", "value": 276, "phone_extension": 158, "password": "DashkovskyEd!158Q2" },
        { "label": "Володько-Бельского", "value": 205, "phone_extension": 205, "password": "VolodkoBels!205H9" },
        { "label": "Евгений Щербин", "value": 197, "phone_extension": 157, "password": "ShcherbinEv!157C6" },
        { "label": "Антон Байсов", "value": 196, "phone_extension": 109, "password": "BaysovAn!109D8" },
        { "label": "Александр Рязанов", "value": 163, "phone_extension": 154, "password": "RyazanovAl!154J3" },
        { "label": "Дмитрий Петкевич", "value": 162, "phone_extension": 192, "password": "PetkevichDm!192G4" },
        { "label": "Евгений Корнев", "value": 107, "phone_extension": 173, "password": "KornevEv!173Z2" },
        { "label": "Иван Романовский", "value": 106, "phone_extension": null, "password": "RomanovskyIv!106M1" },
        { "label": "Дмитрий Шлямин", "value": 105, "phone_extension": 155, "password": "ShlyaminDm!155R9" },
        { "label": "Андрей Иодо", "value": 103, "phone_extension": 205, "password": "IodoAn!205X5" },
        { "label": "Артём Кулеш", "value": 62, "phone_extension": 186, "password": "KuleshAr!186P7" },
        { "label": "Геннадий Савин", "value": 57, "phone_extension": 207, "password": "SavinGe!207K4" },
        { "label": "Дмитрий Гончаров", "value": 42, "phone_extension": 170, "password": "GoncharovDm!170B8" },
        { "label": "Алексей Гамзюк", "value": 14, "phone_extension": null, "password": "GamzyukAl!14Q0" }
      ]
  },
  mutations: {
    // Сохранение фильтров
    saveFilters(state, filters) {
      state.filters = { ...filters };
    },
    // Сохранение текущей страницы
    saveCurrentPage(state, page) {
      state.currentPage = page;
    },
    // Сохранение сортировки
    saveSort(state, sort) {
      state.sort = { ...sort };
    },
    savePerPage(state, perPage) {
      state.perPage = perPage;
    },
    setUser(state, user) {
      console.log('Mutation setUser triggered'); // Консольный вывод
      state.user = user;
    },
    logout(state) {
      console.log('Mutation logout triggered'); // Консольный вывод
      state.user = null;
      localStorage.removeItem('user');
    },
    setProducts(state, { orderId, products }) {
      Vue.set(state.productsByOrderId, orderId, products);
    },
    clearProducts(state, orderId) {
      Vue.set(state.productsByOrderId, orderId, []);
    },
    addProduct(state, { orderId, product }) {
      if (!state.productsByOrderId[orderId]) {
        Vue.set(state.productsByOrderId, orderId, []);
      }

      const existing = state.productsByOrderId[orderId].find(p => p.id === product.id);
      if (existing) {
        existing.quantity = product.quantity;
        // Обновляем метаданные товара (корпус и т.п.), если пришли при повторной загрузке
        if (product.korpus !== undefined && product.korpus !== null && product.korpus !== '') {
          Vue.set(existing, 'korpus', product.korpus);
        }
        if (product.brand !== undefined) Vue.set(existing, 'brand', product.brand);
        if (product.jpg_url !== undefined) Vue.set(existing, 'jpg_url', product.jpg_url);
        if (product.name !== undefined) Vue.set(existing, 'name', product.name);
      } else {
        state.productsByOrderId[orderId].push({ ...product });
      }
    },
    removeProduct(state, { orderId, productId }) {
      if (!state.productsByOrderId[orderId]) return;
      state.productsByOrderId[orderId] = state.productsByOrderId[orderId].filter(p => p.id !== productId);
    },
    updateProductQuantity(state, { orderId, productId, quantity }) {
      const product = state.productsByOrderId[orderId] && state.productsByOrderId[orderId].find(p => p.id === productId);
      if (product) {
        product.quantity = quantity;
      }
    }
  },
  actions: {
    // Action для сохранения фильтров
    saveFilters({ commit }, filters) {
      commit('saveFilters', filters);
    },
    savePerPage({ commit }, perPage) {
      commit('savePerPage', perPage);
    },
    // Action для сохранения текущей страницы
    saveCurrentPage({ commit }, page) {
      commit('saveCurrentPage', page);
    },
    // Action для сохранения сортировки
    saveSort({ commit }, sort) {
      commit('saveSort', sort);
    },
  },
  getters: {
    getFilters: (state) => state.filters,
    getCurrentPage: (state) => state.currentPage,

    getSort: (state) => state.sort,
    getPerPage:(state) => state.perPage || 30, // Значение по умолчанию — 30
    isAuthenticated: state => !!state.user,
    user: state => state.user,
    getProductsByOrderId: (state) => (orderId) => {
      return state.productsByOrderId[orderId] || [];
    },
  }
});

